import TEXTS from '../controller/TextVariables';
import { useContext } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import { Tooltip, StandardTooltipWindow } from './Tooltip';

const OpacitySlider = (props) => {
    const { setThemeOpacity, opacity, theme } = useContext(InterfaceContext);
    const onChangeOpacity = (e) => {
        setThemeOpacity(e.target.value);
    };
    const { label, tooltip } = TEXTS.controls.svi_opacity;
    const id = 'theme-opacity';

    return (
        // <div id="opacity" className={`field theme-${theme.id}`}>
        <div id="opacity" className={`field theme`}>
            <Tooltip id={id} tooltip={tooltip} window={<StandardTooltipWindow id={id} text={tooltip} tooltipPlace="bottom" />}>
                <label htmlFor="opacity-slide">{label}</label>
                <div className="ticks">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <input type="range" name="opacity-slide" id="opacity-slide" min="0" max="100" step="10" value={opacity} onChange={onChangeOpacity} tabIndex={0} />
            </Tooltip>
        </div>
    );
};
export default OpacitySlider;

const OpacitySliderTooltip = () => {
    const { tooltip } = TEXTS.controls.svi_opacity;
    return <StandardTooltipWindow id={'theme-opacity'} text={tooltip} />;
};
export { OpacitySliderTooltip };
